import React, { Fragment, useEffect } from 'react';
import { Box, List, Link, ListItem, Typography, Avatar } from '@material-ui/core';
import { getFullName, getRandomBackgroundColor, getRandomColor, getUserName } from '../../../config/utils';
import { BackArrow } from '../../../config/svg/GlobalSvg';
import { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem } from '../../../services/StorageService';
import { useTranslation } from 'react-i18next';
import { ALIGNMENTMAPS, DASHBOARD, HOME, USER_VIEW } from '../../../config/app-url';
import { PersonalFeedbackAction } from '../../PersonalFeedback/PersonalFeedbackAction';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
	currentDashboardTab,
	currentDashboardTabForSO,
	updateCurrentCycleId,
	updateRoute,
} from '../../../action/common';

export const KpiPeopleHeader: React.FC<any> = (props) => {
	const { t } = useTranslation();
	const { currentUser, listOkrResult, listOkrStatusResult, userDetail } = props;
	const dispatch = useDispatch();
	const goBack = () => {
		removeLocalStorageItem('currentUser');
		removeLocalStorageItem('currentOrganisation');
		const backUrl = JSON.parse(getLocalStorageItem('backUrl') || '{}');
		dispatch(currentDashboardTab(backUrl?.tabValue || 10));
		props.history.push(HOME);
		dispatch(updateRoute(HOME));
	};
	const getStatusName = (code: any, statusName: any) => {
		return (
			<Fragment>
				<Typography variant='body2'>{typeof listOkrResult[code] !== 'object' && listOkrResult[code]}</Typography>
				<Typography>{statusName}</Typography>
			</Fragment>
		);
	};
	useEffect(() => {
		document.body.classList.remove('guideme-home');
	});

	return (
		<Fragment>
			<Box className='back-to-main back-to-main-people'>
				<Typography variant='body2'>
					<Link onClick={goBack} id='back-btn'>
						<BackArrow /> {t('back')}
					</Link>{' '}
					{t('watchingKpis', { name: currentUser.firstName })}
				</Typography>
			</Box>
			<Box className='view-people-info' id='people-info-header'>
				<Box className='view-people-details'>
					<Box className='view-people-info-wrap'>
						{currentUser.imagePath ? (
							<Avatar
								alt=''
								src={currentUser.imagePath}
								className='view-people-img'
								//onClick={handleAvatarOpen}
							/>
						) : (
							<Avatar
								className='view-people-img'
								style={{
									backgroundColor: getRandomBackgroundColor(currentUser.backGroundColorCode),
									color: getRandomColor(currentUser.colorCode),
								}}
							>
								{getUserName(currentUser)}
							</Avatar>
						)}
						<Box className='view-profile-user'>
							<Box className='profile-user-text'>
								<Typography variant='h4'>{getFullName(currentUser)}</Typography>

								<List className='view-profile-des'>
									<ListItem>{listOkrResult?.designation}</ListItem>
									{/* <ListItem>{listOkrResult?.department}</ListItem> */}
								</List>
							</Box>
							<List className='view-profiles-okrs'></List>
							<Box className='view-people-status '></Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Fragment>
	);
};
